import type { Tracker } from './tracker'
import type { CommonCtx, EventMap } from './schema'

let _globalTracker: Tracker | undefined

export function setGlobalTracker(tracker: Tracker | undefined) {
  _globalTracker = tracker
}

export function getGlobalTracker(): Tracker | undefined {
  return _globalTracker
}

export function track<E extends keyof EventMap>(event: E, payload: EventMap[E], ctx?: Partial<CommonCtx>) {
  try { _globalTracker?.track(event, payload as any, ctx) } catch { /* noop */ }
}

export function identify(userId: string, traits?: Record<string, unknown>) {
  try {
    const anyTracker = _globalTracker as any
    if (anyTracker && typeof anyTracker.identify === 'function') anyTracker.identify(userId, traits)
  } catch { /* noop */ }
}
